import { useEffect } from "react";

const useScrollTo = (scrollToPosition = 0, behavior = "auto", deps = []) => {
    useEffect(() => {
        window.scrollTo({ top: scrollToPosition, behavior: behavior, })
    }, deps)
}

export default useScrollTo;